import React from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {failSignIn, successSignIn} from '../../actions/authentication';
import {addNotification} from '../../actions/notifications';
import {getEndpoint, headers} from '../../helpers/endpoint';
import './SignIn.css';

class SignIn extends React.Component {
  onClickGoogleSignin = async () => {
    const {dispatch} = this.props;
    const GoogleUser = await window.gapi.auth2.getAuthInstance().signIn();
    const token = GoogleUser.getAuthResponse().id_token;
    const BasicProfile = GoogleUser.getBasicProfile();
    fetch(getEndpoint('googleSignIn'), {
      method: 'POST',
      headers,
      body: JSON.stringify({token}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          dispatch(
            addNotification({
              type: 'error',
              title: 'Connexion error',
              content: `<p>We couldn't authenticate you. Please check your information.</p>`,
            }),
          );
        } else {
          dispatch(
            successSignIn(data.token, {
              name: BasicProfile.getName(),
              avatarUrl: BasicProfile.getImageUrl(),
            }),
          );
        }
      })
      .catch(err => {
        console.log(err);
        dispatch(failSignIn());
      });
  };

  render() {
    const {from} = this.props.location.state || {from: {pathname: '/'}};
    if (this.props.authentication.isAuthenticated)
      return <Redirect to={from} />;

    return (
      <div id="sign-in" className="login-page animated slideInDown">
        <div className="login-box">
          <div className="login-logo">
            <a href="/">
              Admin<b>MPG</b>
            </a>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
            className="login-box-body">
            <p className="login-box-msg">Sign in and start a new session</p>
            <button
              style={{
                cursor: 'pointer',
                backgroundColor: '#45c945',
                borderRadius: 5,
                padding: 8,
                color: 'white',
                borderWidth: 0,
              }}
              onClick={this.onClickGoogleSignin}>
              Google Sign In
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    return {authentication: state.authentication};
  },
  dispatch => ({dispatch}),
)(SignIn);



// WEBPACK FOOTER //
// ./src/pages/SignIn/index.js